import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GroupLdapDto } from '../../models/entities/group-ldap-dto';
import { restServices } from 'src/app/rest.service';
import { environment } from 'src/environments/environment';

type EntityArrayResponseTypeGruppiLdap = HttpResponse<GroupLdapDto[]>;
type EntityArrayResponseTypeGruppoLdap = HttpResponse<GroupLdapDto>;

@Injectable()
export class GroupService {

  public resourceGruppiLdap = environment.api_url + restServices.gruppiLdap;

  constructor(private http: HttpClient) { }

  getAllGruppi(): Observable<EntityArrayResponseTypeGruppiLdap> {
    return this.http.get<GroupLdapDto[]>(this.resourceGruppiLdap, { observe: 'response' });
  }

  getGruppoByNome(nome: string): Observable<EntityArrayResponseTypeGruppoLdap> {
    return this.http.get<GroupLdapDto>(`${this.resourceGruppiLdap}/${nome}`, { observe: 'response' });
  }

  insertGruppoLdap(gruppoLdap: GroupLdapDto): Observable<EntityArrayResponseTypeGruppoLdap> {
    return this.http.post<GroupLdapDto>(`${this.resourceGruppiLdap}`, gruppoLdap, { observe: 'response' });
  }

  updateGruppoLdap(gruppoLdap: GroupLdapDto): Observable<EntityArrayResponseTypeGruppoLdap> {
    return this.http.put<GroupLdapDto>(`${this.resourceGruppiLdap}`, gruppoLdap, { observe: 'response' });
  }

}
